import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AppStateType } from '../../reducers'
import { selectGroupById } from '../../selectors/groups'
import { selectSearch } from '../../selectors/search'
import { selectCapabilitiesSummaryPerGroup } from '../../selectors/capabilitiesSummary'
import { GroupPublishPage as Page } from './GroupPublishPage'

const mapStateToProps = (state: AppStateType, ownProps) => ({
  search: selectSearch(state),
  group: selectGroupById(ownProps.match.params.groupId)(state),
  groupsLoading: state.groups.isLoading,
  groupsLoaded: state.groups.isLoaded,
  capabilitiesSummary: selectCapabilitiesSummaryPerGroup(
    ownProps.match.params.groupId
  )(state),
})

export const GroupPublishPage = withRouter(
  connect(mapStateToProps)(Page)
) as React.FC<{}>
